export enum MutationTypes {
    SET_CUSTOMER = 'billing-module/set-customer',
    SET_SUBSCRIPTION = 'billing-module/set-subscription',
    SET_PAYMENT_METHOD = 'billing-module/set-payment-method',
    SET_ADDRESS = 'billing-module/set-address',
    SET_INVOICES = 'billing-module/set-invoices',
}